import { atom } from 'jotai';

export type PdpParamsAtom = {
  appearanceId?: string;
  sizeId?: string;
};

export const pdpParamsAtom = atom<PdpParamsAtom | null>(null);

export const pdpParamsWithSyncAtom = atom(
  (get) => get(pdpParamsAtom),
  (get, set, newParams: PdpParamsAtom) => {
    const existingParams = get(pdpParamsAtom);
    set(pdpParamsAtom, { ...existingParams, ...newParams });

    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);

      if (newParams.appearanceId) {
        params.set('appearance', newParams.appearanceId);
      }
      if (newParams.sizeId) {
        params.set('size', newParams.sizeId);
      }
      const search = params.toString();
      const pathname = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`;

      window.history.replaceState(window.history.state, '', pathname);
    }
  }
);
